import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

import Header from "@assets/missing-policy-details/header.webp";

import { FormTextField, LoadingFrame } from "@covertree/ui";
import { InformationBox } from "@covertree/ui/content";
import { useFormWithNotification } from "@covertree/hooks";

import { CONTACT_PHONE_NUMBER, HELP_EMAIL_ADDRESS } from "@consts/index";

import { missingPolicyDetailsValidation } from "./form";
import { ClaimsForm } from "../ClaimsForm";
import { useFindPolicyFormClaimByLocator } from "./useFindPolicyFormClaimByLocator";

export function MissingPolicyDetails() {
  const { findPolicyForClaim, loading } = useFindPolicyFormClaimByLocator();

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: { policyLocator: "" },
    resolver: yupResolver(missingPolicyDetailsValidation),
  });
  const { control } = form;

  if (loading) {
    return (
      <LoadingFrame
        image="/animations/spinner.gif"
        messages={["Looking up policy details"]}
        maxLoadTime={5}
      />
    );
  }

  return (
    <ClaimsForm form={form} onSubmit={findPolicyForClaim}>
      <img
        src={Header}
        alt="policy number"
        style={{
          height: 144,
          maxWidth: 144,
          marginLeft: 8,
          marginBottom: 8,
        }}
      />
      <Grid item xs={12} md={8}>
        <FormTextField
          control={control}
          id="policy-number-field"
          dataTestId="policy-number-field"
          name="policyLocator"
          label="Policy number"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <InformationBox data-testid="disclaimer-box" mt={3}>
          <Typography color="textPrimary">
            Sorry we are unable to locate your policy details. Please enter your
            policy number or reach out to us at{" "}
            <Link color="secondary" href={`tel:${CONTACT_PHONE_NUMBER}`}>
              {CONTACT_PHONE_NUMBER}
            </Link>{" "}
            or{" "}
            <Link color="secondary" href={`mailto:${HELP_EMAIL_ADDRESS}`}>
              {HELP_EMAIL_ADDRESS}
            </Link>
            . We are here to help!
          </Typography>
        </InformationBox>
      </Grid>
    </ClaimsForm>
  );
}
